import api from './api';

/**
 * Servicio para gestionar clientes
 */
export const clientesService = {
  /**
   * Obtener todos los clientes
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {string} buscar - Texto para buscar por nombre, RFC o correo (opcional)
   */
  getAll: async (empresaId = null, sucursalId = null, buscar = null) => {
    const params = {};
    if (empresaId) params.empresaId = empresaId;
    if (sucursalId) params.sucursalId = sucursalId;
    if (buscar) params.buscar = buscar;
    const response = await api.get('/clientes', { params });
    return response;
  },

  /**
   * Buscar clientes por nombre, RFC o correo
   * @param {string} q - Texto de búsqueda
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   */
  buscar: async (q, empresaId = null) => {
    const params = { q };
    if (empresaId) params.empresaId = empresaId;
    const response = await api.get('/clientes/buscar', { params });
    return response;
  },

  /**
   * Obtener un cliente por ID
   */
  getById: async (id) => {
    const response = await api.get(`/clientes/${id}`);
    return response;
  },

  /**
   * Crear un nuevo cliente
   */
  create: async (cliente) => {
    const response = await api.post('/clientes', cliente);
    return response;
  },

  /**
   * Actualizar un cliente
   */
  update: async (id, cliente) => {
    const response = await api.put(`/clientes/${id}`, cliente);
    return response;
  },

  /**
   * Desactivar un cliente (baja lógica)
   */
  delete: async (id) => {
    const response = await api.delete(`/clientes/${id}`);
    return response;
  },
};

